"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.executePromise = void 0;
var cache_promise_1 = require("../cache-promise");
var cleanup_1 = require("./cleanup");
var increment_stats_value_1 = require("./increment-stats-value");
var log_1 = require("./log");
function executePromise(state, opts, fn, key, args) {
    var promise = fn.apply(void 0, __spread(args));
    state.promiseCacheMap[key] = promise;
    trackPromiseExecution(state, opts, promise, key);
    return promise;
}
exports.executePromise = executePromise;
function trackPromiseExecution(state, opts, promise, key) {
    promise
        .then(function (response) {
        if (opts.ttl > 0) {
            log_1.log(opts, "Storing result '" + key + "'");
            state.cacheMap.set(key, {
                time: cache_promise_1.getTime(),
                data: response
            });
            increment_stats_value_1.incrementStatsValue(state, opts, 'put');
            cleanup_1.startCleanupJob(state, opts);
        }
    })
        .catch(function () {
        /* no-op */
    })
        .then(function () {
        log_1.log(opts, "Removing pending promise for '" + key + "'");
        delete state.promiseCacheMap[key];
    });
}
//# sourceMappingURL=execute-promise.js.map